// src/components/Footer.js
import React from 'react';
import "./style.scss"

const Footer = () => {
  return (
    <footer className='footer-main'>
      <p style={{ margin: 0 }}>Copyright © 2025 ProntoCaseCash.</p>
    </footer>
  );
};

export default Footer;
